var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuDownloads(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.959,
    height: 17.959,
    viewBox: "0 0 17.959 17.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_5_x2C__down_x2C__direction_x2C__arrow_x2C__lower_x2C__down_arrow_x2C__sign",
    transform: "translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4169",
    "data-name": "Group 4169",
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4168",
    "data-name": "Group 4168",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2963",
    "data-name": "Path 2963",
    d: "M147.9,140.131l-2.294,2.294v-5.677a.748.748,0,1,0-1.5,0v5.677l-2.294-2.294a.748.748,0,0,0-1.058,1.058l3.576,3.576a.748.748,0,0,0,1.054,0l3.572-3.572a.748.748,0,0,0-1.058-1.058Z",
    transform: "translate(-135.88 -131.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2964",
    "data-name": "Path 2964",
    d: "M24.98,16a8.98,8.98,0,1,0,8.98,8.98A8.975,8.975,0,0,0,24.98,16Zm0,16.463a7.483,7.483,0,1,1,7.483-7.483A7.492,7.492,0,0,1,24.98,32.463Z",
    transform: "translate(-16 -16)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuDownloads);
export default __webpack_public_path__ + "static/media/icon_menu_downloads.d51b112db28339af430b5c770896bb03.svg";
export { ForwardRef as ReactComponent };